import { render, staticRenderFns } from "./ModalTasaInteresAjeno.vue?vue&type=template&id=dbc969aa&"
import script from "./ModalTasaInteresAjeno.vue?vue&type=script&lang=js&"
export * from "./ModalTasaInteresAjeno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports